module.exports = __webpack_public_path__ + "img/default.c7357fdd.jpg";